import { useAtom } from "jotai";
import { navbarAtom } from "../../lib/atoms";
import logo from "../../assets/img/logo.png";
import { HelpCircle, LogOut, MenuIcon, User, UserIcon, X } from "lucide-react";
import { useAuthStatus } from "../../lib/stores/auth-store";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

const Header = () => {
  const [navbarOpen, setNavbar] = useAtom(navbarAtom);
  const signOut = useAuthStatus((state) => state.logout);
  const queryClient = useQueryClient();

  return (
    <div className="w-screen h-14 md:h-20 border-b border-slate-200 bg-white px-6 py-1 fixed flex justify-between items-center z-50">
      <img src={logo} className="h-full" alt="Logo d'ApiConnect" />
      <div>
        <div className="hidden md:block mr-2">
          <DropdownMenu modal={false}>
            <DropdownMenuTrigger>
              <div className="shadow rounded-full hover:bg-slate-50 border p-1">
                <UserIcon />
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuLabel>Mon compte</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <Link to="/coordonnees">
                <DropdownMenuItem>
                  <User size={15} className="mr-4" /> Mes coordonnées
                </DropdownMenuItem>
              </Link>
              <Link to="/aide">
                <DropdownMenuItem>
                  <HelpCircle size={15} className="mr-4" /> Aide
                </DropdownMenuItem>
              </Link>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                onClick={() => {
                  signOut();
                  queryClient.clear();
                }}
              >
                <LogOut size={15} className="mr-4" /> Déconnexion
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
        <div onClick={() => setNavbar(!navbarOpen)} className="block md:hidden">
          {navbarOpen ? <X /> : <MenuIcon />}
        </div>
      </div>
    </div>
  );
};

export default Header;
